import {ElementRef, Injectable} from '@angular/core';
import {OtpService} from './otp.service';

@Injectable()
export class OtpSplitInputService {
  private autofillId: any;
  public inputMaxLength: number = 1;
  public splitInputs: ElementRef<HTMLInputElement>[] = [];

  constructor(public otpService: OtpService) {
  }

  public addInput(elementRef: ElementRef<HTMLInputElement>): void {
    let elementIndex = this.splitInputs.indexOf(elementRef);
    if (elementIndex === -1) {
      this.splitInputs.push(elementRef);
    }
  }

  public removeInput(elementRef: ElementRef<HTMLInputElement>): void {
    let elementIndex = this.splitInputs.indexOf(elementRef);
    if (elementIndex >= 0) {
      this.splitInputs.splice(elementIndex, 1);
    }
  }

  public onFocus(event: FocusEvent, elementRef: ElementRef<HTMLInputElement>): void {
    elementRef.nativeElement.setSelectionRange(0, elementRef.nativeElement.value.length);
  }

  public onBackSpace(event: KeyboardEvent, elementRef: ElementRef<HTMLInputElement>): void {
    let element = elementRef.nativeElement;
    let elementIndex = this.splitInputs.indexOf(elementRef);

    if (elementIndex !== 0 && element.value.length === 0) {
      const previousInput = this.splitInputs[elementIndex - 1];
      previousInput.nativeElement.value = previousInput.nativeElement.value.substring(0, previousInput.nativeElement.value.length - 1);
      previousInput.nativeElement.focus();
      previousInput.nativeElement.click();
    }
  }

  public onChange(event: Event, elementRef: ElementRef<HTMLInputElement>): void {
    let element = elementRef.nativeElement;

    if (element.value?.length > this.inputMaxLength) {
      this.autofill(event, elementRef, element.value);
    }
  }

  public onInput(event: InputEvent, elementRef: ElementRef<HTMLInputElement>): void {
    let element = elementRef.nativeElement;

    if (element.value?.length > this.inputMaxLength) {
      return this.autofill(event, elementRef, element.value);
    }

    if (event.data?.length > this.inputMaxLength) {
      return this.autofill(event, elementRef, event.data);
    }

    let elementIndex = this.splitInputs.indexOf(elementRef);

    if (this.inputMaxLength == element.value.length) {
      if (elementIndex != this.splitInputs.length - 1) {
        const nextInput = this.splitInputs[elementIndex + 1];
        nextInput.nativeElement.focus();
        nextInput.nativeElement.click();
      }
    }

    this.onFormChange();
  }

  public onPaste(event: ClipboardEvent, elementRef: ElementRef<HTMLInputElement>): void {
    let clipboardData: string = (event.clipboardData || (window as any).clipboardData).getData('text');
    if (!clipboardData.length) {
      this.onFormChange();
      return;
    }

    this.autofill(event, elementRef, clipboardData);
  }

  private autofill(event: Event, elementRef: ElementRef<HTMLInputElement>, inputText: string): void {
    if (this.autofillId) {
      clearTimeout(this.autofillId);
    }
    event.preventDefault();
    this.autofillId = setTimeout(() => {
      let elementIndex = this.splitInputs.indexOf(elementRef);
      const remainingElements = this.splitInputs.length - elementIndex;

      for (let i = 0; i < remainingElements; i++) {
        const focusElem = this.splitInputs[elementIndex + i].nativeElement;
        focusElem.value = inputText.substring(0, this.inputMaxLength);

        let inputEvent: InputEvent;
        try {
          inputEvent = new InputEvent('input', {bubbles: true, cancelable: true});
        } catch (e) {
          // IE11
          inputEvent = document.createEvent('Event') as InputEvent;
          inputEvent.initEvent('input', true, true);
        }
        focusElem.dispatchEvent(inputEvent);

        inputText = inputText.slice(this.inputMaxLength);
      }
    }, 0);
  }

  private onFormChange(): void {
    this.otpService.otpCode = '';
    const newOtpCode = this.splitInputs.map(input => {
      return input.nativeElement.value;
    }).join('');

    if (newOtpCode.length === this.otpService.otpCodeLength) {
      this.otpService.otpCode = newOtpCode;
    }
  }

}
